export const createUaEmulator = () => {
    const Methods = {
        updateToken: '$updateToken'
    };
    /**
     * @return {Promise<import("./service").TokenResponse|null>}
     */
    const updateToken = () =>
        new Promise((resolve) => {
            const m = globalThis[Methods.updateToken];

            if (m && typeof m === 'function') {
                m().then(resolve);
                return;
            }
            resolve(null);
        });
    const isAvailable = () =>
        Object.values(Methods).every((method) => {
            const m = globalThis[method];
            return m && typeof m === 'function';
        });

    return { updateToken, isAvailable };
};
